export enum MoneyMapFilterState {
    ALL = 'ALL',
    BILLS = 'BILLS',
    SPEND = 'SPEND',
    GOALS = 'GOALS',
}
